import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: "idle",
  projects: [],
  projectsStatus: "idle",

  error: null,
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
});

// export const {} = dashboardSlice.actions;

export default dashboardSlice.reducer;
